import { render } from "./RouteDetailCard.vue?vue&type=template&id=713eb2c5&scoped=true"
import script from "./RouteDetailCard.vue?vue&type=script&lang=js"
export * from "./RouteDetailCard.vue?vue&type=script&lang=js"

import "./RouteDetailCard.vue?vue&type=style&index=0&id=713eb2c5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713eb2c5"]])

export default __exports__